import { render } from "./StudentCoretime.vue?vue&type=template&id=3898e08e"
import script from "./StudentCoretime.vue?vue&type=script&lang=js"
export * from "./StudentCoretime.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__